import type {FondFieldType} from '../types';
import type {Fond} from 'typings/portaro.be.types';
import type {FondsDataService} from './fonds.data-service';

export class KpFondsService {
    public static serviceName = 'kpFondsService';

    /*@ngInject*/
    constructor(public fondsDataService: FondsDataService) {
    }

    public getAllFonds(): Promise<Fond[]> {
        return this.fondsDataService.getAll();
    }

    public getFondFieldTypes(fond: Fond): Promise<FondFieldType[]> {
        return this.fondsDataService.getFondFieldTypes(fond.id);
    }
}